(function ($) {
  $.fn.wysiwygmodule = function () {
    return this.each((i, el) => {
      const $self = $(el);
      let width = window.innerWidth;
      changeHeightOfOBC($self, width);
      if (window.attachEvent) {
        window.attachEvent('onresize', function () {
          alert('attachEvent - resize');
        });
      } else if (window.addEventListener) {
        window.addEventListener(
          'resize',
          function () {
            let width = window.innerWidth;
            changeHeightOfOBC($self, width);
          },
          true
        );
      } else {
        console.log('The browser does not support Javascript event binding');
      }
    });
  };

  $(() => {
    $('.wysiwyg-module').wysiwygmodule();
  });
  function changeHeightOfOBC(value, width) {
    var $obc_bg_img = value.find('.obc-bg-img');
    var $bg_img = $obc_bg_img.find('.bg-image');
    let $height_obc_bg_img = $obc_bg_img.height();
    let $height_bg_img = $bg_img.height();
    if (
      typeof $height_obc_bg_img !== 'undefined' &&
      typeof $height_bg_img !== 'undefined'
    ) {
      if (width <= 768) {
        $obc_bg_img.css('height', 'auto');
        $bg_img.css('margin-top', '35px');
      } else {
        $bg_img.css('margin-top', '0');
        if ($height_obc_bg_img <= $height_bg_img) {
          $obc_bg_img.css('height', $height_bg_img);
        } else {
          $obc_bg_img.css('height', 'auto');
        }
      }
    }

    var $obc_quote = value.find('.obc-quote');
    var $quote = $obc_quote.find('.quote');
    let $height_obc_quote = $obc_quote.height();
    let $height_quote = $quote.height();
    if (
      typeof $height_obc_quote !== 'undefined' &&
      typeof $height_quote !== 'undefined'
    ) {
      if (width <= 768) {
        $obc_quote.css('height', 'auto');
        $quote.css('margin-top', '60px');
        $quote.css('margin-bottom', '35px');
      } else {
        $quote.css('margin-top', '25px');
        if ($height_obc_quote <= $height_quote) {
          $obc_quote.css('height', $height_quote);
        } else {
          $obc_quote.css('height', 'auto');
        }
      }
    }
  }
})($);



// WEBPACK FOOTER //
// ./scripts/modules/blocks/wysiwyg.js